import React from 'react';
import { AgentList } from '../components/AgentMarketplace';

const AgentMarketplace = () => {
  return <AgentList />;
};

export default AgentMarketplace; 